import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  // Load translations from the /public/locales folder
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: "en",
    // Only these bundles exist. Anything else the detectors find (a mistyped
    // ?lng=, a browser set to Spanish) resolves to the fallback instead of
    // being reported as the page language while English renders.
    supportedLngs: ["en", "de", "fr", "it", "rm"],
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Backend configuration
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    // Language detection options
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => lng.split("-")[0],
    },

    // Default namespace
    defaultNS: "translation",
    ns: ["translation"],

    // React settings
    react: {
      useSuspense: true,
    },
  });

/** Two-letter code of the active language, "en" when nothing is set. */
export function currentLang(instance) {
  return (instance.language || "").slice(0, 2) || "en";
}

export default i18n;
